import React from "react"

import { Helmet } from "react-helmet"

interface IZaim {
  url?: string
  shortTitle?: string
  description?: string
  titleH1?: string
}

export const Zaim = ({ url, shortTitle, description, titleH1 }: IZaim) => (
  <Helmet>
    <script type="application/ld+json">
      {JSON.stringify([
        {
          "@context": "https://schema.org",
          "@type": "BankOrCreditUnion",
          name: "Совкомбанк",
          image: "https://sovcombank.ru/logo.png",
          "@id": "https://sovcombank.ru",
          url: "https://sovcombank.ru/",
          telephone: "8 (800) 700-66-96",
          priceRange: "30 000 - 3 000 000",
          address: {
            "@type": "PostalAddress",
            streetAddress: "Краснопресненская набережная, 14 стр 1",
            addressLocality: "Москва",
            postalCode: "123100",
            addressCountry: "RU",
          },
          openingHoursSpecification: {
            "@type": "OpeningHoursSpecification",
            dayOfWeek: [
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday",
              "Sunday",
            ],
            opens: "00:00",
            closes: "23:59",
          },
          sameAs: [
            "https://ru.wikipedia.org/wiki/Совкомбанк",
            "https://sovcombank.ru",
            "https://www.youtube.com/channel/UCptG0e45r5jZexlXJ_obmvA",
          ],
        },
        {
          "@context": "https://schema.org/",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Совкомбанк",
              item: "https://sovcombank.ru/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "👌 Займ онлайн",
              item: "https://sovcombank.ru/apply/credit/zajm-online/",
            },
            {
              "@type": "ListItem",
              position: 3,
              name: `💰 ${shortTitle}`,
              item: `${url}`,
            },
          ],
        },
        {
          "@context": "https://schema.org/",
          "@type": "Product",
          name: `${titleH1}`,
          image: "https://sovcombank.ru/logo.png",
          description: `${description}`,
          brand: {
            "@type": "Brand",
            name: "Совкомбанк",
          },
          offers: {
            "@type": "AggregateOffer",
            url: `${url}`,
            priceCurrency: "RUB",
            lowPrice: "30000",
            highPrice: "3000000",
          },
          aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: "8,9",
            bestRating: "10",
            worstRating: "1",
            ratingCount: "9322",
          },
        },
      ])}
    </script>
    <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "QAPage",
        mainEntity: {
          "@type": "Question",
          name: "Как оформить займ в банке Совкомбанк",
          text: "Как оформить займ в банке Совкомбанк",
          answerCount: 3,
          suggestedAnswer: [
            {
              "@type": "Answer",
              text: "✍️1. Заполните онлайн-заявку. Это займёт несколько минут.",
            },
            {
              "@type": "Answer",
              text: "⌚2. Дождитесь одобрения. Быстрое решение.",
            },
            {
              "@type": "Answer",
              text: "💳3. Заберите деньги. В офисе Банка или доставкой курьером",
            },
          ],
        },
      })}
    </script>
  </Helmet>
)
